module.exports = __webpack_public_path__ + "static/media/icono_nombre_apellido.06b5edb6.svg";